import { BreackpointsX, BreackpointsY } from '../../utils/enums/breackpoints';
import { Colors } from '../../utils/enums/colors';
import { getLevelValue } from '../../utils/helpers/getLevelValue';
import { Text } from '../../utils/types/gameObjects';
import { EndGame } from '../scenes/endGame';
import { Game } from '../scenes/game';

import { UIController } from './uiController';

export class UiText {
  static LevelTxt(context: Phaser.Scene, level: number): Text {
    const { x, y, fontSize } = UiText.prototype.inGameTopText(context, true);
    const [w] = UIController.widthHeight(context);
    let yPos = y;

    if (w <= BreackpointsX.MOBILE_SM) {
      yPos = y - 7;
    }

    return context.add.text(x, yPos, `L${level}`, {
      fontSize: `${fontSize}px`,
      color: UIController.textColor(),
      fontFamily: "'Press Start 2P', 'cursive'",
    });
  }

  static LivesTxt(context: Phaser.Scene, live: number): Text {
    const { x, y, fontSize } = UiText.prototype.inGameTopText(context, true);
    const [w] = UIController.widthHeight(context);
    let xPos = x + 135;
    let yPos = y;

    if (w <= BreackpointsX.MOBILE_SM) {
      xPos = x + 83;
      yPos = y - 7;
    }

    return context.add.text(xPos, yPos, `${live}`, {
      fontSize: `${fontSize}px`,
      color: UIController.textColor(),
      fontFamily: "'Press Start 2P', 'cursive'",
    });
  }

  static ExitGameText(context: Phaser.Scene): Text {
    const [x, y] = UIController.centerXY(context);
    const [w, h] = UIController.widthHeight(context);

    let xPos = x + 20;
    let yPos = y - 270;
    let fontSize = 48;
    let textWidth = 600;
    let align = 'center';

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      fontSize = 28;

      xPos = x;
      yPos = y - 150;
    }
    if (w <= BreackpointsX.TABLET) {
      fontSize = 24;
      textWidth = w * 0.9;
      yPos = y - 140;
    }
    if (w <= BreackpointsX.MOBILE_SM) {
      textWidth = w * 0.97;
      align = 'left';
      xPos = x + 10;
    }

    return context.add
      .text(xPos, yPos, 'DO YOU WANT TO EXIT THE GAME?', {
        fontSize: `${fontSize}px`,
        color: UIController.textColor(),
        fontFamily: "'Press Start 2P', 'cursive'",
        align,
        maxLines: 2,
        wordWrap: {
          width: textWidth + 120,
        },
      })
      .setOrigin(0.5);
  }

  static WinGameMsg(context: EndGame): Text {
    const { x, y, fontSize } = UiText.prototype.textCenterPos(context, 300, 270);

    return context.add
      .text(x, y, `YOU WIN!`, {
        fontSize: `${fontSize}px`,
        color: UIController.textColor(),
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);
  }

  static EndGameScore(context: EndGame): Text {
    const { x, y, fontSize } = UiText.prototype.textCenterPos(context, 300, 220);

    return context.add
      .text(x, y, `YOUR SCORE ${context?.sceneData?.score}`, {
        fontSize: `${fontSize}px`,
        color: UIController.textColor(),
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);
  }

  static GameScore(context: Game): Text {
    const level = context.gameState.level;
    const score = context.gameState.score;
    const [w, h] = UIController.widthHeight(context);

    const { x, y, fontSize } = UiText.prototype.inGameTopText(context);

    const scoreValue = `${score.toString()}/${getLevelValue(level)}`;

    let xPos = x + 70;
    let yPos = y;

    if (w <= BreackpointsX.TABLET || h <= BreackpointsY.MD) {
      xPos = x + 55;
      yPos = y - 5;
    }

    const gameScoreText = context.add.text(xPos, yPos, scoreValue, {
      fontSize: `${fontSize}px`,
      color: UIController.textColor(),
      fontFamily: "'Press Start 2P', 'cursive'",
    });

    gameScoreText.setOrigin(1, 0);

    return gameScoreText;
  }

  static GameOverScore(context: Phaser.Scene, score: number): Text {
    const [w, h] = UIController.widthHeight(context);
    const { x, y, fontSize } = UiText.prototype.textCenterPos(context, 295);

    let textObject: Phaser.GameObjects.Text;

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      const { y, fontSize } = UiText.prototype.textCenterPos(context, 267);

      textObject = context.add.text(x, y, `SCORE: ${score}`, {
        fontSize: `${fontSize}px`,
        color: UIController.textColor(),
        fontFamily: "'Press Start 2P', 'cursive'",
      });
      textObject.setOrigin(0.5, 0.5);
    } else {
      textObject = context.add.text(x, y, `SCORE: ${score}`, {
        fontSize: `${fontSize}px`,
        color: UIController.textColor(),
        fontFamily: "'Press Start 2P', 'cursive'",
      });
      textObject.setOrigin(0.5, 0.5);
    }

    return textObject;
  }

  static HighScores(context: Phaser.Scene): Text {
    const { x, y, fontSize } = UiText.prototype.textCenterPos(context, 220);

    return context.add
      .text(x, y, 'HIGH SCORES', {
        fontSize: `${fontSize}px`,
        color: UIController.textColor(),
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);
  }

  static PauseGame(context: Phaser.Scene): Text {
    const { x, y, fontSize } = UiText.prototype.textCenterPos(context, 220);

    return context.add
      .text(x, y, 'GAME ON PAUSE', {
        fontSize: `${fontSize}px`,
        color: UIController.textColor(),
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);
  }

  static GameOver(context: Phaser.Scene): Text {
    const { x, y, fontSize } = UiText.prototype.textCenterPos(context, 380, 270);

    return context.add
      .text(x, y, 'GAME OVER', {
        fontSize: `${fontSize}px`,
        color: Colors.ERROR,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);
  }

  static Loading(context: Phaser.Scene): Text {
    const { x, y, fontSize } = UiText.prototype.textCenterPos(context, 110);

    return context.add
      .text(x + 10, y, 'LOADING...', {
        fontSize: `${fontSize}px`,
        color: Colors.BLACK,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);
  }

  textCenterPos(context: Phaser.Scene, offset: number, resOffset?: number) {
    const [w, h] = UIController.widthHeight(context);
    const [x, y] = UIController.centerXY(context);

    let fontSize = 48;
    let textY = y - offset;

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      fontSize = 28;
      textY = resOffset ? y - resOffset : y - offset + 50;
    }

    return { x, y: textY, fontSize };
  }

  inGameTopText(context: Phaser.Scene, left?: boolean) {
    const [w, h] = UIController.widthHeight(context);
    let fontSize = 32;
    let x = left ? 150 : w - 190;
    let y = 38;
    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      fontSize = 28;
      x = left ? 130 : w - 164;
      y = left ? 35 : 33;
    }
    if (w <= BreackpointsX.TABLET) {
      x = left ? 60 : w - 100;
      fontSize = 18;
    }

    return { x, y, fontSize };
  }
}
